/* RIOCAM PRESTIGE — theme.js : AJAX cart, drawer, variant picker */
(function(){
  'use strict';
  var RC = window.RC || {};

  /* ---------- money ---------- */
  function formatMoney(cents){
    cents = Number(cents) || 0;
    var amount = (cents/100).toFixed(2);
    var fmt = RC.money_format || '€{{amount}}';
    var parts = amount.split('.');
    var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = intp + ',' + parts[1];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, intp)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intp);
  }

  function $(s, c){ return (c||document).querySelector(s); }
  function $all(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  var drawer = $('#CartDrawer');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); document.body.style.overflow=''; } }

  function renderCart(cart){
    var count = cart.item_count;
    $all('[data-cart-count]').forEach(function(el){ el.textContent = count; el.style.display = count>0?'':'none'; });

    var itemsEl = $('#CartDrawerItems');
    var emptyEl = $('#CartDrawerEmpty');
    var footEl  = $('#CartDrawerFoot');
    var totalEl = $('#CartDrawerTotal');
    var shipEl  = $('#CartDrawerShip');
    if(!itemsEl) return;

    if(count === 0){
      itemsEl.innerHTML = '';
      if(emptyEl) emptyEl.style.display = 'flex';
      if(footEl) footEl.style.display = 'none';
      return;
    }
    if(emptyEl) emptyEl.style.display = 'none';
    if(footEl) footEl.style.display = 'block';
    if(totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var FREE = 19900;
    if(shipEl){
      var r = FREE - cart.total_price;
      shipEl.textContent = r>0 ? ('Spend ' + formatMoney(r) + ' more for free shipping') : '✓ Free shipping unlocked';
    }

    itemsEl.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '' +
      '<div class="cart-line">' +
        '<div class="cart-line__media">' + (img?'<img src="'+img+'" alt="'+escapeHtml(it.product_title)+'">':'') + '</div>' +
        '<div class="cart-line__main">' +
          '<a class="cart-line__title" href="'+it.url+'">'+escapeHtml(it.product_title)+'</a>' +
          (variant?'<div class="cart-line__variant">'+escapeHtml(variant)+'</div>':'') +
          '<div class="cart-line__controls">' +
            '<div class="qty">' +
              '<button type="button" data-change data-line="'+it.key+'" data-to="'+(it.quantity-1)+'" aria-label="Decrease">−</button>' +
              '<span>'+it.quantity+'</span>' +
              '<button type="button" data-change data-line="'+it.key+'" data-to="'+(it.quantity+1)+'" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-change data-line="'+it.key+'" data-to="0">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line__price">'+formatMoney(it.final_line_price)+'</div>' +
      '</div>';
    }).join('');
  }

  function escapeHtml(s){ return (s||'').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function refreshCart(open){
    fetch(RC.routes.cart, { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); if(open) openDrawer(); })
      .catch(function(){});
  }

  function changeLine(key, qty){
    fetch(RC.routes.cart_change, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id:key, quantity:qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){ renderCart(cart); reloadCartPage(); })
    .catch(function(){});
  }

  function reloadCartPage(){ if(document.body.classList.contains('template-cart')) window.location.reload(); }

  /* ---------- drawer events ---------- */
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-open-cart]');
    if(openBtn){ e.preventDefault(); refreshCart(true); return; }
    if(e.target.closest('[data-close-cart]')){ e.preventDefault(); closeDrawer(); return; }
    var ch = e.target.closest('[data-change]');
    if(ch){ e.preventDefault(); changeLine(ch.getAttribute('data-line'), parseInt(ch.getAttribute('data-to'),10)); return; }
    var co = e.target.closest('[data-checkout]');
    if(co){ e.preventDefault(); window.location.href = RC.routes.checkout; return; }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

  /* ============================================================
     ADD TO CART (AJAX)
     ============================================================ */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action$="/cart/add"], form#ProductForm');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"]');
    var prev = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = '…'; }
    fetch(RC.routes.cart_add, {
      method:'POST',
      headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
    .then(function(res){
      if(btn){ btn.disabled = false; btn.textContent = prev; }
      if(!res.ok){ if(btn){ btn.textContent = (res.d && res.d.description) || 'Unavailable'; setTimeout(function(){ btn.textContent = prev; }, 1800); } return; }
      refreshCart(true);
    })
    .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=prev; } });
  });

  /* ============================================================
     VARIANT / SIZE PICKER (PDP)
     ============================================================ */
  $all('[data-product-form]').forEach(function(scope){
    var dataEl = $('[data-variants-json]', scope);
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var optionsCount = variants.length ? variants[0].options.length : 0;
    var selected = new Array(optionsCount).fill(null);
    var idInput = $('[name="id"]', scope);
    var priceEl = $('[data-pdp-price]', scope);
    var addBtn = $('[name="add"]', scope);

    // preselect from first available variant
    var firstAvail = variants.find(function(v){ return v.available; }) || variants[0];
    if(firstAvail){ selected = firstAvail.options.slice(); }

    function matchVariant(){
      return variants.find(function(v){
        return v.options.every(function(o, i){ return selected[i] == null || o === selected[i]; }) &&
               selected.every(function(s, i){ return s == null || v.options[i] === s; });
      });
    }
    function valueAvailable(optIndex, value){
      return variants.some(function(v){
        if(v.options[optIndex] !== value) return false;
        return selected.every(function(s, i){ return i===optIndex || s==null || v.options[i]===s; }) && v.available;
      });
    }
    function render(){
      $all('.opt-val', scope).forEach(function(b){
        var oi = parseInt(b.getAttribute('data-index'),10);
        var val = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', String(selected[oi] === val));
        b.disabled = !valueAvailable(oi, val);
      });
      var v = matchVariant();
      if(v){
        if(idInput) idInput.value = v.id;
        if(priceEl) priceEl.textContent = formatMoney(v.price);
        if(addBtn){
          if(v.available){ addBtn.disabled = false; addBtn.textContent = RC.strings.addToCart || 'Add to cart'; }
          else { addBtn.disabled = true; addBtn.textContent = RC.strings.soldOut || 'Sold out'; }
        }
      } else if(addBtn){
        addBtn.disabled = true; addBtn.textContent = RC.strings.pickOption || 'Select a size';
      }
    }
    scope.addEventListener('click', function(e){
      var b = e.target.closest('.opt-val'); if(!b || b.disabled) return;
      var oi = parseInt(b.getAttribute('data-index'),10);
      selected[oi] = b.getAttribute('data-value');
      render();
    });
    render();
  });

  /* ============================================================
     PRODUCT GALLERY (thumb → main)
     ============================================================ */
  $all('.pdp__thumbs').forEach(function(strip){
    var main = document.getElementById('PdpMain');
    strip.addEventListener('click', function(e){
      var b = e.target.closest('.pdp__thumb'); if(!b) return;
      var full = b.getAttribute('data-full');
      if(full && main){ main.style.opacity = '0'; setTimeout(function(){ main.src = full; main.style.opacity = '1'; }, 120); }
      $all('.pdp__thumb', strip).forEach(function(t){ t.classList.remove('is-active'); });
      b.classList.add('is-active');
    });
  });

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  var menuToggle = $('[data-menu-toggle]');
  if(menuToggle){ menuToggle.addEventListener('click', function(){ var nav = $('#SiteNav'); if(nav) nav.classList.toggle('is-open'); }); }

  /* initial count */
  refreshCart(false);
})();
